import AppAnalytics from '../analytics/AppAnalytics';
import '../components/header-nav';
import '../components/email-modal';
import '../components/homepage-ctas';
import '../components/train-lora-form';
import '../components/generate-images-form';
import '../components/image-carousel';
import '../components/tools-tabs';
import '../components/waitlist-cta';

(window as typeof window & { AppAnalytics: typeof AppAnalytics }).AppAnalytics = AppAnalytics;

// Initialize analytics
AppAnalytics.getPlausible();

